module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-controls create-slot-lightbox">\n    <div class="row slot-name">\n        <div class="col-xs-12 editable-container">\n            <h4>\n                <div contenteditable="' +
__e( !notAllowedToPublish) +
'" class="editable name';
if(notAllowedToPublish){;
__p += ' disabled';
};
__p += '" ';
if(notAllowedToPublish){;
__p += 'disabled';
};
__p += '>' +
__e( slotName ) +
'</div>\n            </h4>\n        </div>\n    </div>\n    <div class="row slot-info-container">\n        <div class="col-xs-4">\n            <div class="title">CSS Selector</div>\n            <input type="text" class="selector';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' placeholder="Enter CSS Selector">\n        </div>\n        <div class="col-xs-4">\n            <div class="title">URL</div>\n            <input type="text" class="url';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' placeholder="URL (optional)">\n        </div>\n    </div>\n    <div class="row experience-info-container">\n        <div class="col-xs-4">\n            <div class="channel-numeric-icon title" data-icon-number="1">Live</div>\n            <input type="hidden" class="live-select';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>\n        </div>\n        <div class="col-xs-4">\n            <div class="channel-numeric-icon title" data-icon-number="2">Scheduled</div>\n            <input type="hidden" class="next-select';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>\n        </div>\n        <div class="col-xs-4">\n            <div class="form-group">\n                <div class="title">Scheduled Date</div>\n                <div class="empty-schedule-date"> - </div>\n                <div class=\'input-group date next-start-time-picker\'>\n                    <input type=\'text\' class="form-control next-start-time';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' data-format="yyyy-MM-dd"/>\n                    ';
 if (!notAllowedToPublish) { ;
__p += '\n                        <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span>\n                    ';
 } ;
__p += '\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="actions">\n        <span class="slot-schedule-notification">Scheduling \'No Experience\' will take down the Live Experience from your Slot.</span>\n        <button class="btn-ok btn btn-primary pull-right';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>OK</button>\n        <button class="btn-cancel btn btn-secondary pull-right">Cancel</button>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/publish/channelSetup/ChannelPropertiesView.tpl
// module id = 2843
// module chunks = 0